import { render, staticRenderFns } from "./SideMenus.vue?vue&type=template&id=759a1b6a&scoped=true&"
import script from "./SideMenus.vue?vue&type=script&lang=js&"
export * from "./SideMenus.vue?vue&type=script&lang=js&"
import style0 from "./SideMenus.vue?vue&type=style&index=0&id=759a1b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759a1b6a",
  null
  
)

export default component.exports